export const inviteStatus = {
  expired: 0,
  valid: 1,
  invalid: 2,
};

export const porterDeliveryStandardStep = Object.freeze({
  0: 'phone number',
  1: 'group unity',
  2: 'unity',
  3: 'open drawer',
  4: 'confirm deposit',
  5: 'feedback success',
});

export const porterDeliveryStandardStepNames = Object.freeze({
  phoneNumber: 0,
  groupUnity: 1,
  unity: 2,
  openDrawer: 3,
  confirmDeposit: 4,
  feedbackSuccess: 5,
});

export const porterDeliveryCorreiosStep = Object.freeze({
  0: 'credentialAccess',
  1: 'groupUnity',
  2: 'unity',
  3: 'confirmDeliveryUnity',
  4: 'openDrawer',
  5: 'confirmDeposit',
  6: 'deliveryReceipt',
  7: 'deliveryProblem',
  8: 'deliverySuccess',
});

export const porterDeliveryCorreiosStepNames = Object.freeze({
  credentialAccess: 0,
  groupUnity: 1,
  unity: 2,
  confirmDeliveryUnity: 3,
  openDrawer: 4,
  confirmDeposit: 5,
  deliveryReceipt: 6,
  deliveryProblem: 7,
  deliverySuccess: 8,
});

export default inviteStatus;
